import React from 'react';

const BaDriverIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 14C12 12.9391 11.5786 11.9217 10.8284 11.1716C10.0783 10.4214 9.06087 10 8 10M8 10C6.93913 10 5.92172 10.4214 5.17157 11.1716C4.42143 11.9217 4 12.9391 4 14M8 10C9.47276 10 10.6667 8.80609 10.6667 7.33333C10.6667 5.86057 9.47276 4.66667 8 4.66667C6.52724 4.66667 5.33333 5.86057 5.33333 7.33333C5.33333 8.80609 6.52724 10 8 10ZM3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333C2 2.59695 2.59695 2 3.33333 2Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default BaDriverIcon;
